import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    deadline: "",
    project: "",
    subscribe: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  return (
    <div className="w-full mx-auto py-16 px-10 font-secondary text-white bg-black md:py-16 md:px-8">
      <div className="max-w-[1200px] mx-auto">
        <h1 className="text-4xl md:text-6xl text-white mb-8 font-normal font-primary text-center tracking-wider">
          Contact Us
        </h1>

        {/* Single centered contact card similar to the provided design */}
        <div className="max-w-5xl mx-auto mb-12 p-20">
          <div className="bg-black/80 border border-white/6 rounded-3xl overflow-hidden transition-transform duration-200 transform hover:-translate-y-1 hover:shadow-2xl hover:border-white/10">
            <div className="flex items-start gap-6 px-8 py-10">
              {/* left icon */}
              <div className="flex-shrink-0 pt-1">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-white/90"
                >
                  <path
                    d="M21 11.5C21 16.1944 16.9706 20 12 20C10.5632 20 9.19378 19.6766 8 19.1L3 21.5L4.4 16.6C3.82338 15.4062 3.5 14.0368 3.5 12.6C3.5 7.90558 7.52944 4.1 12.5 4.1C17.4706 4.1 21.5 7.90558 21.5 12.6H21Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {/* content */}
              <div className="flex-1">
                <h3 className="text-xl text-white font-medium mb-2">
                  Contact Product Support
                </h3>
                <p className="text-white/60 mb-6">
                  For all things related to FOZZIL and our products.
                </p>

                <div className="flex flex-wrap gap-3">
                  <a
                    href="mailto:support@fozzil.in"
                    className="inline-block border border-white/10 text-white/90 px-5 py-2 rounded-full text-sm tracking-widest hover:bg-white/10"
                  >
                    EMAIL SUPPORT
                  </a>
                  <a
                    href="tel:+919791597197"
                    className="inline-block border border-white/10 text-white/90 px-5 py-2 rounded-full text-sm tracking-widest hover:bg-white/10"
                  >
                    CALL SUPPORT
                  </a>
                </div>
              </div>

              {/* right spacer to mimic wide card */}
              <div className="w-6" />
            </div>
          </div>
        </div>

        {/* Three-column social/contact row (icons + heading + subtitle) */}
        <div className="max-w-6xl mx-auto mt-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 border-l border-r border-white/6">
            <a
              href="https://twitter.com/fozzilai"
              target="_blank"
              rel="noopener noreferrer"
              className="group block"
            >
              <div className="px-8 py-12 border-r border-white/6 flex items-start gap-6 transition-transform duration-200 transform group-hover:-translate-y-1 group-hover:shadow-lg group-hover:bg-white/3">
                <div className="flex-shrink-0">
                  {/* placeholder icon */}
                  <img
                    src={process.env.PUBLIC_URL + "/logoicon.png"}
                    alt="FOZZIL X"
                    className="w-10 h-10"
                  />
                </div>
                <div>
                  <h4 className="text-xl text-white mb-2">Visit FOZZIL on X</h4>
                  <p className="text-white/60">
                    Visit our official FOZZIL X account.
                  </p>
                </div>
              </div>
            </a>

            <a
              href="https://instagram.com/fozzilai"
              target="_blank"
              rel="noopener noreferrer"
              className="group block"
            >
              <div className="px-8 py-12 border-r border-white/6 flex items-start gap-6 transition-transform duration-200 transform group-hover:-translate-y-1 group-hover:shadow-lg group-hover:bg-white/3">
                <div className="flex-shrink-0">
                  <img
                    src={process.env.PUBLIC_URL + "/logoicon.png"}
                    alt="FOZZIL AI"
                    className="w-10 h-10"
                  />
                </div>
                <div>
                  <h4 className="text-xl text-white mb-2">
                    Visit FOZZIL AI Instagram
                  </h4>
                  <p className="text-white/60">
                    Visit our official FOZZIL AI Instagram account.
                  </p>
                </div>
              </div>
            </a>

            <a
              href="https://discord.gg/DK6UTNRJ"
              target="_blank"
              rel="noopener noreferrer"
              className="group block"
            >
              <div className="px-8 py-12 flex items-start gap-6 transition-transform duration-200 transform group-hover:-translate-y-1 group-hover:shadow-lg group-hover:bg-white/3">
                <div className="flex-shrink-0">
                  <img
                    src={process.env.PUBLIC_URL + "/logoicon.png"}
                    alt="Discord"
                    className="w-10 h-10"
                  />
                </div>
                <div>
                  <h4 className="text-xl text-white mb-2">
                    Join FOZZIL on Discord
                  </h4>
                  <p className="text-white/60">
                    Visit our official FOZZIL Discord community.
                  </p>
                </div>
              </div>
            </a>
          </div>

          <div className="mt-12 px-8 grid grid-cols-2 gap-8 text-white/80">
            <div>
              <div className="text-xs uppercase tracking-widest text-white/50 mb-1">
                Media
              </div>
              <div className="text-lg">media@fozzil.in</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-white/50 mb-1">
                Safety
              </div>
              <div className="text-lg">safety@fozzil.in</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
/* --- IGNORE --- */
